import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import AstroImage from '@/components/ui/custom/AstroImage';
import {
  AnswerContentKind,
  AnswerContentSource,
  resolveAnswerContentKind,
} from '@/utils/questions/resolveAnswerContentKind';

export const answerContentClassNames: Record<AnswerContentKind, string> = {
  text: '',
  image: 'h-16 w-16 object-cover',
};

type AnswerContentProps = {
  answer: AnswerContentSource;
  className?: string;
};

function TextContent({ answer, className }: AnswerContentProps) {
  return (
    <span className={twMerge(answerContentClassNames.text, className)}>
      {answer.text ?? ''}
    </span>
  );
}

function ImageContent({ answer, className }: AnswerContentProps) {
  return (
    <AstroImage
      zoomable
      src={answer.mediaFile?.url ?? answer.mediaLink ?? ''}
      alt={answer.altText ?? ''}
      className={twMerge(answerContentClassNames.image, className)}
    />
  );
}

const CONTENT_RENDERERS: Record<AnswerContentKind, FC<AnswerContentProps>> = {
  text: TextContent,
  image: ImageContent,
};

export function AnswerContent({ answer, className }: AnswerContentProps) {
  const Renderer = CONTENT_RENDERERS[resolveAnswerContentKind(answer)];
  return <Renderer answer={answer} className={className} />;
}
